import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtMoney, fmtNumber, monthLabel } from "@/lib/fmt";
import { Link } from "react-router-dom";
import { Users, BookOpen, Receipt, ArrowRight } from "lucide-react";

export default function AdminOverview() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/overview").then(({ data }) => setData(data)); }, []);
  if (!data) return <div className="text-hh-ink2">Loading…</div>;

  const cards = [
    { label: "Authors on roster", value: fmtNumber(data.authors), icon: Users, to: "/admin/authors" },
    { label: "Titles in catalogue", value: fmtNumber(data.titles), icon: BookOpen, to: "/admin/titles" },
    { label: "Transactions ingested", value: fmtNumber(data.transactions), icon: Receipt, to: "/admin/upload" },
  ];

  return (
    <div className="space-y-12" data-testid="admin-overview-page">
      <header>
        <p className="hh-overline mb-3">Admin · Overview</p>
        <h1 className="font-serif text-4xl text-hh-ink tracking-tight">Healing House at a glance</h1>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {cards.map(({ label, value, icon: Icon, to }) => (
          <Link key={label} to={to} className="hh-card hh-card-hover p-7 block" data-testid={`overview-card-${label.replace(/\s/g, "-").toLowerCase()}`}>
            <div className="flex items-start justify-between mb-4">
              <span className="h-10 w-10 rounded-full bg-hh-muted grid place-items-center">
                <Icon size={18} strokeWidth={1.5} className="text-hh-primary" />
              </span>
              <ArrowRight size={16} className="text-hh-ink2" />
            </div>
            <div className="font-serif text-4xl text-hh-ink">{value}</div>
            <p className="mt-2 text-sm text-hh-ink2">{label}</p>
          </Link>
        ))}
      </div>

      <section>
        <p className="hh-overline mb-4">Compensation received from IngramSpark</p>
        <div className="hh-card p-8 grid grid-cols-1 sm:grid-cols-3 gap-6">
          {Object.entries(data.by_currency || {}).map(([ccy, v]) => (
            <div key={ccy} data-testid={`overview-ccy-${ccy}`}>
              <div className="hh-overline mb-2">{ccy}</div>
              <div className="font-serif text-3xl text-hh-ink">{fmtMoney(v.net, ccy)}</div>
              <div className="text-xs text-hh-ink2 mt-1">{fmtNumber(v.units)} units</div>
            </div>
          ))}
          {Object.keys(data.by_currency || {}).length === 0 && (
            <div className="text-hh-ink2 text-sm">No reports ingested yet. Upload your first one →</div>
          )}
        </div>
      </section>

      <section>
        <p className="hh-overline mb-4">Reporting periods on file</p>
        <div className="flex flex-wrap gap-2">
          {data.periods.map((p) => (
            <span key={p} className="px-4 py-2 rounded-full bg-hh-muted text-sm text-hh-ink">
              {monthLabel(p)}
            </span>
          ))}
          {data.periods.length === 0 && <p className="text-sm text-hh-ink2">No data yet.</p>}
        </div>
      </section>
    </div>
  );
}
